export default __webpack_public_path__ + "1544b1ba2dd58fa9bd8c0e4d3786737c.png";